import React from 'react';
import { Container } from 'components/common';
import contact from 'assets/illustrations/contact.svg';
import { Wrapper, Details, Thumbnail } from './styles';
import ContactForm from './ContactForm';

export const Contact = () => (
  <Wrapper as={Container} id="contact">
    <Details>
      {/*<ContactForm />*/}
        <iframe
            src="https://docs.google.com/forms/d/e/1FAIpQLSf1qAJiNOVLuvAFn527QyxzwoxFJOAVO2sE0YnX3gwRyVEHNA/viewform?embedded=true"
            width="640" height="382" frameBorder="0" marginHeight="0" marginWidth="0">Loading…
        </iframe>
    </Details>
    <Thumbnail>
      <img src={contact} alt="I’m John and I’m a Backend & Devops engineer!" />
    </Thumbnail>
  </Wrapper>
);
